<template>
  <div style="width: 1200px; margin: 0 auto; background-color: #F2F6FC;">
    <Title :title="{name: '项目变更申请', path:'/item'}"></Title>
    <el-card class="box-card" style="min-height: 650px;margin-top: 15px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="left" label-width="150px">
        <el-divider content-position="left">项目选择</el-divider>
        <el-form-item label="变更项目" prop="projectId">
          <el-select style="margin-right: 15px; width: 50%" v-model="ruleForm.projectId"
            placeholder="请选择变更项目" filterable @change="getProjetInfo">
            <el-option
              v-for="item in projectList"
              :key="item.projectId"
              :label="item.projectName"
              :disabled="item.projectState === 6"
              :value="item.projectId">
              <span style="float: left">{{ item.projectName }}&nbsp&nbsp{{item.projectIden}}</span>&nbsp&nbsp
              <el-tag v-if="item.projectState === 6" type="info" size="mini">S: 已终止</el-tag>
              <span style="float: left">&nbsp&nbspM: {{ item.managerName }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-divider content-position="left">项目信息</el-divider>

        <el-form-item label="项目名称" prop="projectName">
          <el-input v-model="ruleForm.projectName"></el-input>
        </el-form-item>

        <el-form-item label="项目预计金额" prop="projectAmountExpect">
          <el-input v-model="ruleForm.projectAmountExpect" maxlength="12">
            <template slot="append">{{ getDigitUppercase }}</template>
          </el-input>
        </el-form-item>

        <el-form-item label="项目状态" prop="projectState">
          <el-radio-group v-model="ruleForm.projectState">
            <el-radio label="1">已沟通</el-radio>
            <el-radio label="2">已采购</el-radio>
            <el-radio label="3">已签约</el-radio>
            <el-radio label="4">已回款</el-radio>
            <el-radio label="5">已实施</el-radio>
            <el-radio label="6">项目终止</el-radio>
            <el-radio label="7">已完成</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="项目概况" prop="surveyBody">
          <el-input type="textarea" rows="5" maxlength="500"
                    show-word-limit v-model="ruleForm.surveyBody"></el-input>
        </el-form-item>

        <el-form-item label="项目负责人" prop="projectName">
          <el-select v-model="ruleForm.projectManager" placeholder="请选择项目负责人" filterable>
            <el-option
                v-for="item in sysUserList"
                :key="item.userId"
                :label='item.realName'
                :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button :disabled="disabled" type="primary" @click="submit">提交申请</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Title from "../../Title";
import {digitUppercase, isNum} from "@/util";
import {requestManageProject,requestProjectDetail,requestAddProjectModify,requestApplyDetail,requestUserGet,requestAllProject} from "@/api";
export default {
  components: {Title},
  name: "ProjectModifyApply",
  computed: {
    getDigitUppercase() {
      return digitUppercase(this.ruleForm.projectAmountExpect)
    },
  },
  data() {
    const validatePrice = (rule, value, callback) => {
      if (!value) {
        callback(new Error("金额不能为空"));
      } else if (!isNum(value)) {
        callback(new Error("请输入正确格式的金额"));
      } else if (value.split(".").length > 2) {
        callback(new Error("请输入正确格式的金额")); //防止输入多个小数点
      } else if (value.indexOf(".") > -1 && value.substring(value.indexOf(".") + 1).length > 2) {
        callback(new Error("最大保留两位小数"));
      } else if (value.length > 12) {
        callback(new Error("长度最大12个字符"))
      } else {
        this.ruleForm.projectAmountExpect = value
        callback();
      }
    };
    return {
      disabled: true,
      projectList: [],
      sysUserList: [],
      ruleForm: {
        projectId: "",
        projectName: "",
        projectState: "",
        projectAmountExpect: "",
        projectManager: "",
        surveyBody: ""
      },
      rules: {
        projectId: [
          {required: true, message: '请选择要变更的项目', trigger: 'blur'},
        ],
        projectName: [
          {required: true, message: '请输入项目名称', trigger: 'blur'},
          {max: 200, message: '长度最大200个字符', trigger: 'blur'}
        ],
        projectAmountExpect: [
          {required: true, validator: validatePrice, trigger: 'blur'},
        ],
        projectState: [
          {required: true, message: '请选择项目状态', trigger: 'blur'},
        ],
        surveyBody: [
          {required: true, message: '请输入项目概况', trigger: 'blur'},
        ],
      }
    }
  },
  created() {
    this.getAllProject()
    this.loadSysUserData()
    this.applyId = this.$route.query.applyId
    this.applyServiceId = this.$route.query.applyServiceId
    this.applyType = this.$route.query.applyType
    if (this.applyId || this.applyServiceId || this.applyType) {
      this.reapply = true
      this.disabled = false
      this.getObject()
    }
  },
  methods: {
    async loadSysUserData() {
      let res = await requestUserGet();
      if (res.code === 200) {
        this.sysUserList = res.object;
      } else {
        this.$message.error("获取人员列表失败")
      }
    },
    getAllProject() {
      requestAllProject({}).then(res => {
        if (res.code === 200) {
          if (res.object) {
            this.projectList = res.object
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    async getObject() {
      const param = {
        applyId: this.applyId,
        applyServiceId: this.applyServiceId,
        applyType: this.applyType
      }
      const res = await requestApplyDetail(param)
      if (res.code === 200) {
        this.ruleForm.projectId = res.object.projectModify.projectId
        this.ruleForm.projectName = res.object.projectModify.projectName
        this.ruleForm.projectAmountExpect = res.object.projectModify.projectAmountExpect.toString()
        this.ruleForm.projectState = res.object.projectModify.projectState.toString()
        this.ruleForm.projectManager = res.object.projectModify.projectManager
        this.ruleForm.surveyBody = res.object.projectModify.surveyBody
      }
    },
    getProjetInfo(id) {
      this.disabled = false
      requestProjectDetail({projectId: id}).then(res => {
        if (res.code === 200) {
          if (res.object) {
            let detail = res.object.detail
            this.ruleForm.projectAmountExpect = detail.projectAmountExpect.toString()
            this.ruleForm.projectName = detail.projectName
            this.ruleForm.projectState = detail.projectState.toString()
            this.ruleForm.projectManager = detail.projectManager
            let surveys = res.object.surveys
            this.ruleForm.surveyBody = surveys[surveys.length - 1].surveyBody
          }
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.disabled= true
          if (this.reapply) {
            this.ruleForm.applyId = this.applyId
          }
          requestAddProjectModify(this.ruleForm).then(res => {
            if (res.code === 200) {
              this.$message.success(res.msg);
              if (this.reapply) {
                this.$router.push({query: {}})
              }
              this.resetForm()
              this.disabled= false
            } else {
              this.$message.error(res.msg);
            }
          })
        }
      })
    },
    resetForm() {
      this.$refs["ruleForm"].resetFields()
      this.ruleForm.projectManager = ""
    }
  }
}
</script>

<style>

</style>
